// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c97919a3","453":"72b644f9","732":"29185939","977":"0d67914c"}[chunkId] + ".chunk.js";
};